import React, {useState} from 'react';
import {Drawer, MainLayout} from '../../../../ui';
import {Tabs} from '../../../assessment/view/tabs/tabs';
import {CCAResultsSection} from '../JobOpeningDetails/JobPosting/CCATab/CCAResultsSection';
import {Analytic3D} from './AnalysisSideMenu/Analytic3D';
import {AnalyticFilter} from './AnalysisSideMenu/AnalyticFilter';
import {CandidateProfile} from './CandidateProfile';
import {CandidateProfileModal} from './CandidateProfileModal';
import {SearchResults, Toolbar} from './Components';
import {CandidateStatusLegend} from './Components/CandidateStatusLegend';
import {CCAFilterDrawerContent} from './Components/CCAFilterDrawerContent';
import {PreQualFilterDrawerContent} from './Components/PreQualFilterDrawerContent';
import {UnsuccessfulEmailConfirmationModal} from './Components/UnsuccessfulEmailConfirmationModal';
import {ColumnConfiguration} from './Containers/ColumnConfiguration';
import {Overview} from './Containers/Overview';
import {useGetSidebarButtons} from './Functions/GetSideBarButtons';
import {useApplicantAnalysis} from './Hooks/UseApplicantAnalysis';
import {TableView} from './TableView';
import {TwoDChart} from './TwoDChart';

interface AllApplicantAnalysisProps {
    jobOpeningElements: any
}

export const AllApplicantAnalysis = ({jobOpeningElements}: AllApplicantAnalysisProps) => {
    const {
        activeTab,
        updateActiveTab,
        tabTitles,
        filteredCandidates,
        loading,
        candidates,
        currentTab,
        globalSearchTerm,
        setIsAnalyticalFilter,
        isAnalyticalFilter,
        clearSelection,
        setIsColumnConfigurationOpen,
        handleExportClick,
        setShowSearchPanel,
        showSearchPanel,
        handleSendEmailToSelected,
        handleSendEmailToSingleApplicant, // Add single applicant email function
        setView3D,
        view3D,
        setSvgActiveTab,
        setIsToolbarExpanded,
        isToolbarExpanded,
        selectedApplicantsForEmail,
        viewMode,
        setViewMode,
        selectAllUnsuccessful,
        setGlobalSearchTerm,
        svgActiveTab,
        extractedSkill,
        extractedBehavioralScore,
        extractedJobTitles,
        extractedKeywords,
        setTabTitles,
        setActiveTab,
        markLines,
        setMarkLines,
        nineBox,
        setNineBox,
        selectedCandidates,
        setSelectedCandidates,
        handleApplicantSelection,
        isApplicantSelected,
        setExactKeyword,
        exactKeyword,
        setSearchCSVObject,
        searchCSVObject,
        skillValue,
        setSkillValue,
        experienceValue,
        setExperienceValue,
        scatter,
        setScatter,
        setKeywordList,
        useSkillPercentage,
        handleCandidateClickFromChart,
        colorList,
        projection,
        boxWidthDepth,
        maxLegion,
        isSeriesModal,
        setIsSeriesModal,
        seriesCandidates,
        setSeriesCandidates,
        columns,
        setColumns,
        defaultSkills,
        getColumns,
        aiScoreWeights,
        handleMoveToUnsuccessful,
        handleBulkStatusChange,
        getApplicantInitials,
        handleViewApplicantProfile,
        handleStatusChange,
        isColumnConfigurationOpen,
        defaultSkillsCol,
        setStatus,
        statusValue,
        minMaxAge,
        setMinMaxAge,
        jobTitleInput,
        setJobTitleInput,
        behavioralAttr,
        setBehavioralAttr,
        setSimilarKeyword,
        similarKeyword,
        genderList,
        setGenderList,
        statusList,
        setStatusList,
        similarToggle,
        setSimilarToggle,
        ageToggle,
        setAgeToggle,
        keywordList,
        id,
        searchObject,
        setSearchObject,
        setExtractedSkill,
        setExtractedJobTitles,
        setExtractedKeywords,
        setExtractedBehavioralScore,
        weightingEnabled,
        setWeightingEnabled,
        keywordWeightage,
        setKeywordWeightage,
        similarBehavior,
        setSimilarBehavior,
        similarJobTitle,
        setSimilarJobTitle,
        keywordToggle,
        setKeywordToggle,
        setUseSkillPercentage,
        isAnalytical3D,
        setIsAnalytical3D,
        setColorList,
        setProjection,
        setBoxWidthDepth,
        isProfileModalOpen,
        setIsProfileModalOpen,
        profileModalCandidates,
        setProfileModalCandidates,
        profileModalInitialIndex,
        setProfileModalInitialIndex,
        profileModalTileName,
        setProfileModalTileName,
        handleRefreshData,
        isEmailConfirmationModalOpen,
        isEmailSending,
        handleConfirmSendEmail,
        handleCloseEmailConfirmationModal,
        setSelectedApplicantsForEmail,
        showHeadshots,
        setShowHeadshots,
        handleCloseTab,
        setPrequalFilter,
        prequal_filter,
    } = useApplicantAnalysis();

    const [isPreQualFilterOpen, setIsPreQualFilterOpen] = useState(false);
    const [isCCAFilterOpen, setIsCCAFilterOpen] = useState(false);

    // Get sidebar buttons using the custom hook
    const sidebarButtons = useGetSidebarButtons();



    const renderTab = () => {
        if (activeTab === 0) {
            return (
                <Overview
                    jobOpeningId={id}
                    candidates={filteredCandidates}
                    loading={loading}
                />
            );
        } else if (activeTab === 1) {
            return (
                <div className='min-w-0'>
                    <Toolbar
                        isAnalytical3D={isAnalytical3D}
                        handleGraphConfig={() => setIsAnalytical3D(true)}
                        candidateCount={candidates.length}
                        currentTab={currentTab}
                        filteredCandidateCount={filteredCandidates.length}
                        globalSearchTerm={globalSearchTerm}
                        handleAnalyticsFilterOpen={() =>
                            setIsAnalyticalFilter(!isAnalyticalFilter)
                        }
                        handleClearSelected={clearSelection}
                        handleColumnConfig={() => setIsColumnConfigurationOpen(true)}
                        handleExport={handleExportClick}
                        handleSearchPanelToggle={() => setShowSearchPanel(!showSearchPanel)}
                        handleSendEmailToSelected={handleSendEmailToSelected}
                        handleToggle3DView={() => {
                            setView3D(!view3D);
                            setSvgActiveTab(-1);
                        }}
                        handleToolbarToggle={() => setIsToolbarExpanded(!isToolbarExpanded)}
                        handleRefreshData={handleRefreshData}
                        is3dView={view3D}
                        isAnalyticalFilter={isAnalyticalFilter}
                        isToolbarExpanded={isToolbarExpanded}
                        selectedApplicantCount={selectedApplicantsForEmail.length}
                        viewMode={viewMode}
                        isAnalyticsFilterOpen={isAnalyticalFilter}
                        isClearDisabled={selectedApplicantsForEmail.length === 0}
                        setViewMode={setViewMode}
                        isSearchPanelShow={showSearchPanel}
                        isSendEmailDisabled={selectedApplicantsForEmail.length === 0}
                        loading={loading}
                        selectAllUnsuccessful={selectAllUnsuccessful}
                        setGlobalSearchTerm={setGlobalSearchTerm}
                        setSvgActiveTab={setSvgActiveTab}
                        setView3D={setView3D}
                        svgActiveTab={svgActiveTab}
                        view3D={view3D}
                        candidates={filteredCandidates}
                        showHeadshots={showHeadshots}
                        setShowHeadshots={setShowHeadshots}
                        handleStatusChange={handleStatusChange}
                        handlePreQualFilterOpen={() => setIsPreQualFilterOpen(true)}
                        isPreQualFilterOpen={isPreQualFilterOpen}
                        handleCCAFilterOpen={() => setIsCCAFilterOpen(true)}
                        isCCAFilterOpen={isCCAFilterOpen}
                    />
                    <CandidateStatusLegend candidates={filteredCandidates}/>
                    { /* <CandidateStatusLegend candidates={filteredCandidates} /> */}
                    <div className='flex min-w-0 flex-col gap-3 xl:flex-row'>
                        { /* Main Chart Area */}
                        <div className={`min-w-0 ${showSearchPanel ? 'flex-1' : 'w-full'}`}>
                            {viewMode === 'grid' ? (
                                <TwoDChart
                                    allCandidates={candidates}
                                    setIsProfileModalOpen={setIsProfileModalOpen}
                                    setProfileModalCandidates={setProfileModalCandidates}
                                    setProfileModalInitialIndex={setProfileModalInitialIndex}
                                    setProfileModalTileName={setProfileModalTileName}
                                    additionalSkills={{
                                        skills: extractedSkill.map((s) => ({
                                            skill: s.skill,
                                            weight: s.weight,
                                        })),
                                    }}
                                    behavioralAttributes={{
                                        behavioralAttributes: extractedBehavioralScore.map(
                                            (b) => b.skill,
                                        ),
                                    }}
                                    jobTitles={{
                                        jobTitles: extractedJobTitles.map((j) => j.skill),
                                    }}
                                    keywords={{
                                        keywords: extractedKeywords.map((k) => ({
                                            keyword: k.skill,
                                            weight: k.weight,
                                        })),
                                    }}
                                    tabTitles={tabTitles}
                                    setTabTitles={setTabTitles}
                                    setActiveTab={setActiveTab}
                                    markLines={markLines}
                                    setMarkLines={setMarkLines}
                                    nineBox={nineBox}
                                    setNineBox={setNineBox}
                                    selectedCandidates={selectedCandidates}
                                    setSelectedCandidates={setSelectedCandidates}
                                    selectedApplicantsForEmail={selectedApplicantsForEmail}
                                    onApplicantSelection={handleApplicantSelection}
                                    isApplicantSelected={isApplicantSelected}
                                    currentTab={currentTab}
                                    setExactKeyword={setExactKeyword}
                                    exactKeyword={exactKeyword}
                                    view3D={view3D}
                                    setView3D={setView3D}
                                    searchCSVObject={searchCSVObject}
                                    setSearchCSVObject={setSearchCSVObject}
                                    candidates={filteredCandidates}
                                    skillValue={skillValue}
                                    setSkillValue={setSkillValue}
                                    experienceValue={experienceValue}
                                    setExperienceValue={setExperienceValue}
                                    loading={loading}
                                    scatter={scatter}
                                    setScatter={setScatter}
                                    svgActiveTab={svgActiveTab}
                                    setKeywordList={setKeywordList}
                                    useSkillPercentage={useSkillPercentage}
                                    colorList={colorList}
                                    onCandidateClick={handleCandidateClickFromChart}
                                    projection={projection}
                                    boxWidthDepth={boxWidthDepth}
                                    maxLegion={maxLegion}
                                    isSeriesModal={isSeriesModal}
                                    setIsSeriesModal={setIsSeriesModal}
                                    seriesCandidates={seriesCandidates}
                                    setSeriesCandidates={setSeriesCandidates}
                                    showHeadshots={showHeadshots}
                                />
                            ) : (
                                <TableView
                                    candidates={filteredCandidates}
                                    loading={loading}
                                    tabTitles={tabTitles}
                                    setActiveTab={setActiveTab}
                                    setTabTitles={setTabTitles}
                                    selectedCandidates={selectedCandidates}
                                    setSelectedCandidates={setSelectedCandidates}
                                    columns={columns}
                                    setColumns={setColumns}
                                    getColumns={getColumns}
                                    matchedSkills={defaultSkills}
                                    aiScoreWeights={aiScoreWeights}
                                    onMoveToUnsuccessful={handleMoveToUnsuccessful}
                                    onBulkStatusChange={handleBulkStatusChange}
                                    onCandidateClick={handleCandidateClickFromChart}
                                    selectedApplicantsForEmail={selectedApplicantsForEmail}
                                    handleApplicantSelection={handleApplicantSelection}
                                    isApplicantSelected={isApplicantSelected}
                                    selectAllUnsuccessful={selectAllUnsuccessful}
                                    clearSelection={clearSelection}
                                    handleSendEmailToSelected={handleSendEmailToSelected}
                                    currentTab={currentTab}
                                />
                            )}
                        </div>

                        { /* Search Results Panel */}

                        {showSearchPanel && filteredCandidates.length > 0 && (
                            <SearchResults
                                filteredCandidates={filteredCandidates}
                                getApplicantInitials={getApplicantInitials}
                                handleViewApplicantProfile={handleViewApplicantProfile}
                                setShowSearchPanel={setShowSearchPanel}
                            />
                        )}
                    </div>
                </div>
            );
        } else {
            const tabCandidate = selectedCandidates.find(
                (item) => item.tabId === activeTab,
            );
            const candidateValues = tabCandidate?.candidate;
            if (candidateValues) {
                return (
                    <CandidateProfile
                        key={candidateValues.userId}
                        selectedCandidate={candidateValues}
                        handleSendEmailToSingleApplicant={handleSendEmailToSingleApplicant}
                    />
                );
            } else if (tabTitles[activeTab] === 'CCA Results') {
                return <CCAResultsSection jobOpeningId={id ?? ''}/>;
            }
        }
    };

    const handleRemoveApplicantFromEmail = (userId: string) => {
        setSelectedApplicantsForEmail((prev) =>
            prev.filter((a) => a.userId !== userId),
        );
    };

    const handleClearAllEmailSelection = () => {
        clearSelection();
    };

    return (
        <div className='mt-3 flex flex-col gap-3 sm:mt-5 lg:flex-row lg:gap-6'>
            {activeTab < 2 && (
                <div
                    className='flex w-full gap-1.5 overflow-x-auto rounded-lg border border-slate-100 bg-slate-50/70 p-1.5 lg:sticky lg:top-4 lg:h-fit lg:w-16 lg:shrink-0 lg:flex-col lg:gap-2 lg:overflow-visible lg:rounded-2xl lg:py-3'>
                    {sidebarButtons.map((button, index) => {
                        if (button.disabled) return null;
                        const isActive = currentTab === button.label;
                        const Icon = button.Icon;
                        return (
                            <button
                                key={index}
                                onClick={() => handleStatusChange(button.label)}
                                className='group flex min-w-fit flex-row items-center gap-1.5 px-1 transition-all duration-200 lg:min-w-0 lg:flex-col lg:gap-0 lg:px-0'
                            >
                                <div
                                    className={`w-7 h-7 rounded-lg flex shrink-0 items-center justify-center transition-all duration-300 border lg:w-9 lg:h-9 lg:rounded-xl ${
                                        isActive
                                            ? 'bg-emerald-600 border-emerald-600 text-white shadow-lg shadow-emerald-100 lg:scale-105'
                                            : 'bg-white border-slate-200 text-slate-400 hover:border-emerald-400 hover:text-emerald-600 group-hover:shadow-md'
                                    }`}
                                >
                                    <Icon
                                        className={`w-3.5 h-3.5 lg:w-4 lg:h-4 ${
                                            isActive ? 'text-white' : 'text-slate-400'
                                        }`}
                                    />
                                </div>
                                <p
                                    className={`text-[9px] font-bold uppercase tracking-tight text-left leading-tight transition-colors lg:mt-1 lg:text-center lg:text-[7.5px] ${
                                        isActive
                                            ? 'text-emerald-600'
                                            : 'text-slate-400 group-hover:text-emerald-500'
                                    }`}
                                >
                                    {button.label}
                                </p>
                            </button>
                        );
                    })}
                </div>
            )}
            <MainLayout isLoading={loading}>
                <Tabs
                    tabTitles={tabTitles}
                    setTabTitles={setTabTitles}
                    activeTab={activeTab}
                    setActiveTab={updateActiveTab}
                    onClose={handleCloseTab}
                    addClose={true}
                />
                {renderTab()}
            </MainLayout>
            <ColumnConfiguration
                isOpen={isColumnConfigurationOpen}
                onCloseDrawer={() => setIsColumnConfigurationOpen(false)}
                columns={columns}
                setColumns={setColumns}
                getColumns={getColumns}
                jobSkills={defaultSkillsCol}
            />
            <AnalyticFilter
                isOpen={isAnalyticalFilter}
                onCloseDrawer={() => setIsAnalyticalFilter(false)}
                setStatus={setStatus}
                statusValue={statusValue}
                minMaxAge={minMaxAge}
                setMinMaxAge={setMinMaxAge}
                defaultJobTitles={jobTitleInput}
                setDefaultJobTitles={setJobTitleInput}
                behavioralAttributes={behavioralAttr}
                setBehavioralAttributes={setBehavioralAttr}
                setSimilarKeyword={setSimilarKeyword}
                similarKeyword={similarKeyword}
                loading={loading}
                genderList={genderList}
                setGenderList={setGenderList}
                statusList={statusList}
                setStatusList={setStatusList}
                similarToggle={similarToggle}
                setSimilarToggle={setSimilarToggle}
                ageToggle={ageToggle}
                setAgeToggle={setAgeToggle}
                keywordList={keywordList}
                setKeywordList={setKeywordList}
                jobOpId={id}
                searchObject={searchObject}
                setSearchObject={setSearchObject}
                searchCSVObject={searchCSVObject}
                setSearchCSVObject={setSearchCSVObject}
                extractedSkill={extractedSkill}
                setExtractedSkill={setExtractedSkill}
                extractedJobTitles={extractedJobTitles}
                setExtractedJobTitles={setExtractedJobTitles}
                extractedKeywords={extractedKeywords}
                setExtractedKeywords={setExtractedKeywords}
                extractedBehavioralScore={extractedBehavioralScore}
                setExtractedBehavioralScore={setExtractedBehavioralScore}
                weightingEnabled={weightingEnabled}
                setWeightingEnabled={setWeightingEnabled}
                keywordWeightage={keywordWeightage}
                setKeywordWeightage={setKeywordWeightage}
                similarBehavior={similarBehavior}
                setSimilarBehavior={setSimilarBehavior}
                similarJobTitle={similarJobTitle}
                setSimilarJobTitle={setSimilarJobTitle}
                keywordToggle={keywordToggle}
                setKeywordToggle={setKeywordToggle}
                setUseSkillPercentage={setUseSkillPercentage}
            />
            <Analytic3D
                isOpen={isAnalytical3D}
                onCloseDrawer={() => setIsAnalytical3D(false)}
                scatter={scatter}
                setScatter={setScatter}
                view3D={view3D}
                setView3D={setView3D}
                markLines={markLines}
                setMarkLines={setMarkLines}
                nineBox={nineBox}
                setNineBox={setNineBox}
                setSimilarKeyword={setSimilarKeyword}
                similarKeyword={similarKeyword}
                setExactKeyword={setExactKeyword}
                exactKeyword={exactKeyword}
                setKeywordList={setKeywordList}
                colorList={colorList}
                setColorList={setColorList}
                useSkillPercentage={useSkillPercentage}
                setUseSkillPercentage={setUseSkillPercentage}
                setExperienceValue={setExperienceValue}
                experienceValue={experienceValue}
                expTitle='Total Years of Experience'
                skillTitle='Total number of Skills'
                skillValue={skillValue}
                setSkillValue={setSkillValue}
                setSvgActiveTab={setSvgActiveTab}
                projection={projection}
                setProjection={setProjection}
                boxWidthDepth={boxWidthDepth}
                setBoxWidthDepth={setBoxWidthDepth}
            />

            { /* Candidate Profile Modal */}
            <CandidateProfileModal
                isOpen={isProfileModalOpen}
                onClose={() => setIsProfileModalOpen(false)}
                candidates={profileModalCandidates}
                initialIndex={profileModalInitialIndex}
                tileName={profileModalTileName}
                handleSendEmailToSingleApplicant={handleSendEmailToSingleApplicant}
                onCandidateChange={() => {
                }}
            />

            { /* Unsuccessful Email Confirmation Modal */}
            <UnsuccessfulEmailConfirmationModal
                isOpen={isEmailConfirmationModalOpen}
                onClose={handleCloseEmailConfirmationModal}
                onConfirm={handleConfirmSendEmail}
                selectedApplicants={selectedApplicantsForEmail}
                loading={isEmailSending}
                onRemoveApplicant={handleRemoveApplicantFromEmail}
                onClearAll={handleClearAllEmailSelection}
            />

            <Drawer
                isOpen={isPreQualFilterOpen}
                onClose={() => setIsPreQualFilterOpen(false)}
                title='Pre-Qualification Filters'
                width='w-full md:w-1/3'
            >
                <PreQualFilterDrawerContent
                    jobOpeningId={id}
                    prequal_filter={prequal_filter}
                    setPrequalFilter={setPrequalFilter}
                    searchObject={searchObject}
                    onApply={() => setIsPreQualFilterOpen(false)}
                />
            </Drawer>

            <Drawer
                isOpen={isCCAFilterOpen}
                onClose={() => setIsCCAFilterOpen(false)}
                title='CCA Filters'
                width='w-full md:w-[420px]'
            >
                <CCAFilterDrawerContent onApply={() => setIsCCAFilterOpen(false)}/>
            </Drawer>
        </div>
    );
};
